import { useStandardPriceForm } from './useStandardPriceForm'
import {
  PriceField,
  TextInputField,
  InputSelectControlField,
  Box,
  Flex
} from '@sequencehq/core-components'
import { PricingModelField } from '../common/PricingModelField'
import { ReadOnlyDetails } from '../common/ReadOnlyDetails'
import { ExternalLedgerForm } from '../common/ExternalLedgerForm/ExternalLedgerForm'
import { Currency } from '@sequencehq/api'
import {
  ShowAdditionalFieldsToggle,
  useShowAdditionalFields
} from '../common/ShowAdditionalFieldsToggle'
import { ListPriceField } from '../common/ListPriceField'
import { BillingTypeField } from '../common/BillingTypeField'
import { BillingFrequencyField } from '../common/BillingFrequencyField'

export const StandardPriceVariantForm = () => {
  const { fieldsConfig, priceDetails } = useStandardPriceForm()
  const { showAdditionalFields } = useShowAdditionalFields()

  return (
    <Flex direction="column" gap="16px">
      <ListPriceField />
      <ReadOnlyDetails>
        {priceDetails.map(({ label, value }) => (
          <ReadOnlyDetails.Item key={label} label={label} value={value} />
        ))}
      </ReadOnlyDetails>

      <TextInputField
        label="Display name (appears on invoice)"
        data-testid="standard.name"
        value={fieldsConfig.name.value}
        onChange={e => fieldsConfig.name.onChange(e.target.value)}
        validationErrors={fieldsConfig.name.validationErrors}
        isDisabled={fieldsConfig.name.disabled}
        placeholder="Enter a display name"
      />

      <Flex alignItems="flex-start" gap="4px">
        <PriceField
          label="Price"
          data-testid="standard.price"
          value={fieldsConfig.price.value}
          onChange={newValue => fieldsConfig.price.onChange(newValue)}
          validationErrors={fieldsConfig.price.validationErrors}
          currency={fieldsConfig.currency.value}
          isDisabled={fieldsConfig.price.disabled}
          borderTopRightRadius={0}
          borderBottomRightRadius={0}
          variant="v2"
        />
        {!fieldsConfig.currency.hidden && (
          <Box mt={6}>
            <InputSelectControlField
              data-testid="standard.currency"
              value={fieldsConfig.currency.value}
              onChange={newCurrency =>
                fieldsConfig.currency.onChange(newCurrency as Currency)
              }
              options={fieldsConfig.currency.options}
              validationErrors={fieldsConfig.currency.validationErrors}
              disabled={fieldsConfig.currency.disabled}
              placeholder="Select currency"
              width="150px"
            />
          </Box>
        )}
      </Flex>

      <ShowAdditionalFieldsToggle />
      <Flex
        width="100%"
        display={!showAdditionalFields ? 'none' : 'flex'}
        flexDirection="column"
        gap="16px"
      >
        <PricingModelField />

        <BillingFrequencyField
          data-testid="standard.billingFrequency"
          value={fieldsConfig.billingFrequency.value}
          options={fieldsConfig.billingFrequency.options}
          onChange={fieldsConfig.billingFrequency.onChange}
          validationErrors={fieldsConfig.billingFrequency.validationErrors}
          isDisabled={fieldsConfig.billingFrequency.disabled}
        />

        <BillingTypeField
          value={fieldsConfig.billingType.value}
          onChange={newValue => {
            fieldsConfig.billingType.onChange(newValue)
          }}
          isDisabled={fieldsConfig.billingType.disabled}
          data-testid="standard.billingType"
        />
        <ExternalLedgerForm />
      </Flex>
    </Flex>
  )
}
